export default __webpack_public_path__ + "static/benefitBgImage-d020ff8dbd2d5440af5fa9b0975a76fc.png";